export default "__VITE_ASSET__Y3mwLSBh__"